export default __webpack_public_path__ + "images/226ae1cc516c2c292cb5357f5ab40cda.svg";